<template>
    <b-alert
        variant="seashell-peach"
        :show="show"
        class="maintenance-warning bg-seashell-peach py-2 px-0 rounded-0 mb-0"
    >
        <div class="maintenance-warning-item">
            <div
                class="
                    d-flex
                    flex-column flex-lg-row
                    justify-content-between
                    maintenance-warning-item__content
                "
            >
                <div
                    class="d-flex"
                    :class="{
                        'align-items-center': !data.content[$i18n.locale],
                    }"
                >
                    <i
                        class="
                            fas
                            fa-exclamation-triangle
                            text-cinnabar text-xl
                            mt-2
                            warning-icon
                            align-self-baseline
                        "
                    ></i>
                    <div class="mr-4 mb-0 text-md">
                        <div
                            :class="{
                                'line-clamps-2': isMobile && !expandContent,
                            }"
                            class="font-weight-500"
                            @click="expandContent = !expandContent"
                        >
                            <span class="text-arapawa">
                                {{
                                    $t(
                                        'maintenance.system_maintenance_scheduled_on'
                                    )
                                }}
                            </span>
                            <span class="text-primary">
                                {{
                                    data.startDate
                                        | moment(DATE_FORMAT_WITH_TIME)
                                }}
                            </span>
                            <span class="text-arapawa">
                                {{ $t('maintenance.until') }}
                            </span>
                            <span class="text-primary">
                                {{
                                    data.endDate | moment(DATE_FORMAT_WITH_TIME)
                                }}
                            </span>
                        </div>
                        <component
                            v-model="expandContent"
                            :is="isMobile ? 'b-collapse' : 'div'"
                            v-if="data.content[$i18n.locale]"
                            class="text-break text-grey text-sm"
                        >
                            {{ data.content[$i18n.locale] || '' }}
                        </component>
                    </div>
                </div>
                <div
                    v-if="!forceShow"
                    class="d-flex align-items-center justify-content-end"
                >
                    <b-button
                        variant="transparent"
                        class="
                            font-weight-500
                            text-grey text-nowrap
                            btn-do-not-show
                            p-0
                        "
                        @click="doNotShowAgain"
                    >
                        {{ $t('maintenance.dont_show_again') }}
                    </b-button>
                    <b-button
                        variant="transparent"
                        class="text-grey text-xl p-0"
                        @click="close"
                    >
                        <i class="fal fa-times"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-alert>
</template>

<script>
import { DATE_FORMAT_WITH_TIME } from '@/constants/config';
import { STORAGE_KEY } from '@/constants/storage';
import { isMobile } from 'mobile-device-detect';
import { mapState } from 'vuex';

export default {
    name: 'MaintenanceAlertItem',
    props: {
        data: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
    data() {
        const maintenanceWarningKey =
            STORAGE_KEY.MAINTENANCE_WARNING + '.' + this.data.id;

        const alertTime =
            Number(
                process?.env?.VUE_APP_SHOW_ALERT_MAINTENANCE_TIMEOUT_IN_SECS
            ) || 3600;
        const startDate = new Date(this.data.startDate);
        const preStartDate = new Date(startDate.getTime() - alertTime * 1000);

        return {
            DATE_FORMAT_WITH_TIME,
            maintenanceWarningKey,
            currentTime: new Date(),
            preStartDate,
            intervalFunc: null,
            tempClose: false,
            isMobile,
            expandContent: !isMobile,
        };
    },
    computed: {
        ...mapState('maintenance', ['maintenanceList']),
        forceShow() {
            return this.currentTime >= this.preStartDate;
        },
        show() {
            const doNotShowAgain = this.$cookies.get(
                this.maintenanceWarningKey
            );

            if (this.forceShow && doNotShowAgain) {
                this.$cookies.remove(this.maintenanceWarningKey);
            }
            return this.forceShow || (!doNotShowAgain && !this.tempClose);
        },
    },
    watch: {
        show: {
            immediate: true,
            handler(value) {
                if (value) {
                    clearInterval(this.intervalFunc);
                } else {
                    this.setRealTime();
                }
            },
        },
    },
    destroyed() {
        clearInterval(this.intervalFunc);
    },
    methods: {
        setRealTime() {
            this.intervalFunc = setInterval(() => {
                this.currentTime = new Date();
            }, 1000);
        },
        close() {
            this.tempClose = true;
        },
        doNotShowAgain() {
            this.$cookies.set(
                this.maintenanceWarningKey,
                true,
                new Date(this.data.endDate),
                null,
                '.' + process.env.VUE_APP_DOMAIN
            );
            this.close();
        },
    },
};
</script>
<style lang="scss" scoped>
@import 'MaintenanceAlertItem';
</style>
